export const ASRS = 
{
    Metadata:{Name:'ASRS',maxColumn:5,numRows:18},
    Sections:
    [
        {
            Headers:[
                "Please answer the questions below, rating yourself on each of the criteria shown " +
                "using the scale on the right side of the page. As you answer each question, please " + 
                "check the box that best describes how you have felt and conducted " + 
                "yourself <span class='importantText'>over the past 6 months.</span>",
                "Never",
                "Rarely",
                "Sometimes",
                "Often",
                "Very Often"
            ],
            Questions:[
                {
                    Prompt:"1. How often do you make careless mistakes when you have to work on a boring or difficult project?",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"}
                    ]
                },
                {
                    Prompt:"2. How often do you have difficulty keeping your attention when you are doing boring or repetitive work?",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"}
                    ]
                },
                {
                    Prompt:"3. How often do you have difficulty concentrating on what people say to you, even when they are speaking to you directly?",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"}
                    ]
                },
                {
                    Prompt:"4. How often do you have trouble wrapping up the final details of a project, once the challenging parts have been done?",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"}
                    ]
                },
                {
                    Prompt:"5. How often do you have difficulty getting things in order when you have to do a task that requires organization?",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"}
                    ]
                },
                {
                    Prompt:"6. When you have a task that requires a lot of thought, how often do you avoid or delay getting started?",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"}
                    ]
                },
                {
                    Prompt:"7. How often do you misplace or have difficulty finding things at home or at work?",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"}
                    ]
                },
                {
                    Prompt:"8. How often are you distracted by activity or noise around you?",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"}
                    ]
                },
                {
                    Prompt:"9. How often do you have problems remembering appointments or obligations?",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"}
                    ]
                },
                {
                    Prompt:"10. How often do you fidget or squirm with your hands or feet when you have to sit down for a long time?",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"}
                    ]
                },
                {
                    Prompt:"11. How often do you leave your seat in meetings or other situations in which you are expected to remain seated?",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"}
                    ]
                },
                {
                    Prompt:"12. How often do you feel restless or fidgety?",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"}
                    ]
                },
                {
                    Prompt:"13. How often do you have difficulty unwinding and relaxing when you have time to yourself?",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"}
                    ]
                },
                {
                    Prompt:"14. How often do you feel overly active and compelled to do things, like you were driven by a motor?",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"}
                    ]
                },
                {
                    Prompt:"15. How often do you find yourself talking too much when you are in social situations?",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"}
                    ]
                },
                {
                    Prompt:"16. When you’re in a conversation, how often do you find yourself finishing" +
                    "the sentences of the people you are talking to, before they can finish" +
                    " themselves?",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"}
                    ]
                },
                {
                    Prompt:"17. How often do you have difficulty waiting your turn in situations when " + 
                    "turn taking is required?" ,
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"}
                    ]
                },
                {
                    Prompt:"18. How often do you interrupt others when they are busy?",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"}
                    ]
                }
            ]
        }
    ]
}